export default {
    SET_LOGIN_ERROR: "SET_LOGIN_ERROR",
    REMOVE_LOGIN_ERROR: "REMOVE_LOGIN_ERROR",
    UPDATE_CHAT_DATA: "UPDATE_CHAT_DATA",
}